import { useQuery } from '@tanstack/vue-query'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { PLAYGAMA_CLIDS } from '@/constants/general'
import { usePersisterFn } from '@/query/persister-plugin'
import { Persisters } from '@/query/shared'
import { useAppStore } from '@/store/app-store'
import { useAPI } from '@/utils/requests/api-plugin'

const GOOGLE_ALWAYS_ENABLED_CLIDS = new Set(Object.values(PLAYGAMA_CLIDS))

export function useGoogleProvidersEnabled() {
    const { clid, isPortalEnv } = storeToRefs(useAppStore())
    const api = useAPI()
    const persister = usePersisterFn(Persisters.HighCardinality)

    const queryKey = computed(() => ['google-providers-enabled', clid.value, isPortalEnv.value])

    const { data, refetch } = useQuery({
        queryKey,
        // do not automatically fetch query on SSR or mount, only when "refetch" is called inside InitWrapper onServerPrefetch
        enabled: false,
        queryFn: () => {
            if (isPortalEnv.value || GOOGLE_ALWAYS_ENABLED_CLIDS.has(clid.value)) {
                return true
            }
            return api.getGoogleProvidersEnabled(clid.value)
        },
        persister,
    })

    return {
        isGoogleProvidersEnabled: computed(() => data.value ?? true),
        fetchGoogleProvidersEnabled: () => refetch().catch(() => undefined),
    }
}
